const routes = [
  {
    path: "/financeiro/baixa-contas-receber",
    component: () =>
      import("@/views/dashboard/baixa-de-contas/BaixaDeContasReceber.vue"),
    meta: {
      menu: "dashboard",
      title: { text: "global.conta", plural: true },
      icon: "mdi-barn",
      breadcrumb: [
        { text: "global.home", to: { path: "/" } },
        { text: "global.baixaDeContas" },
      ],
      permission: { componente: "BaixaContas" },
    },
  },
  {
    path: "/financeiro/baixa-contas-pagar",
    component: () =>
      import("@/views/dashboard/baixa-de-contas/BaixaDeContasPagar.vue"),
    meta: {
      menu: "dashboard",
      title: { text: "global.baixaDeContas" },
      icon: "mdi-barn",
      breadcrumb: [
        { text: "global.home", to: { path: "/" } },
        { text: "global.baixaDeContas" },
      ],
      permission: { componente: "BaixaContas" },
    },
  },
];

export default routes;
